// Resolve the server origin (no trailing slash) from VITE_AUTH_SERVER_URL or
// the page's location. Mirrors the rule used by main.tsx so an avatar URL
// like '/avatars/<agentId>.png?v=…' renders correctly across both dev (page
// on :5175 → server on :4000) and deployed (page + server share origin).

export function serverOrigin(): string {
  const explicit = import.meta.env.VITE_AUTH_SERVER_URL as string | undefined;
  if (explicit && explicit !== 'auto') return explicit.replace(/\/$/, '');
  if (typeof window !== 'undefined' && window.location?.hostname) {
    const { protocol, hostname, port } = window.location;
    if (port && port !== '80' && port !== '443') return `${protocol}//${hostname}:4000`;
    return `${protocol}//${hostname}`;
  }
  return 'http://localhost:4000';
}

/** Resolve `/avatars/...` (or any server-relative path) into an absolute URL.
 *  Pass-throughs absolute URLs untouched. */
export function resolveAvatarUrl(url: string): string {
  if (/^https?:\/\//.test(url)) return url;
  return `${serverOrigin()}${url.startsWith('/') ? '' : '/'}${url}`;
}
